import React from 'react'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import medicines from '../Images/medicines.png'
import Cardsection from '../Components/Cardsection';
import bot from  '../Images/bot.png'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Gallerysection from '../Components/Gallerysection';
import '../App.css';
import About from '../Components/About';
import Timing from '../Components/Timing';
import Contact from '../Components/Contact';

function Body() {
  const renderTooltip = (props) => (
    <Tooltip className='tooltip' id="button-tooltip" {...props}>
      Chat with us!
    </Tooltip>
  );
  return (
    <>
    <div>
      <Row className='w-100 mt-5'>
        <Col>
          <img className='handimg' src={medicines} alt="" />
        </Col>
        <Col className='colu2 mt-5'>
          <p className='quote'>“ Wherever the art of medicine is loved, there is also a love for humanity ”<span className='coluspan'> - Hippocrates</span></p>
        </Col>
      </Row>
    </div>

    <div>
      <About/>
    </div>

    <div>
    <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    >
        <a href="https://wa.me/919961750288" target='_blank'><img  style={{position:'fixed',zIndex:'1'}} className='whats' src={bot} width={70} alt="" /></a>
    </OverlayTrigger>
    </div>
    <div className='mt-5' style={{textAlign:'center'}}>
      <h2 className='serv'>Services</h2>
        <Cardsection/>
    </div>

    <div className='mt-5 mb-5'>
      <h2 className='serv'>Shop Timings</h2>
      <Timing/>
    </div>

    <div>
      <h2 className='serv mt-3 mb-3' style={{textAlign:'center'}}>Gallery</h2>
        <Gallerysection/>
    </div>

    <div className='mt-3'>
        <Contact/>
    </div>
    </>
  )
}

export default Body